<!-- Contenu principal du menu mobile -->
<div class="scroll-y" *ngIf="!showWizardMenu">
  <section *ngIf="authenticationService.isLoggedIn()">
    <app-user [theme]="'light'"></app-user>
    <a (click)="onCallbackRequest()"><i class="fa fa-fw fa-phone"></i>{{ 'buttons.callbackRequest' | translate }}<i
        class="fa fa-angle-right"></i></a>
  </section>
  <section>
    <h6>{{ 'header.cart' | translate }}</h6>
    <a [routerLink]="['/order-in-progress']" *ngIf="order">
      <i class="fa fa-shopping-cart"></i>
      <span *ngIf="order.count > 0; else noArticle">
        <ng-container *ngIf="order.weight?.net || order.weight?.gross">{{ (order.weight?.net || order.weight?.gross) +
          order.weight?.unit }}</ng-container>
        <ng-container *ngIf="order.price?.total && (order.weight?.net || order.weight?.gross)">|</ng-container>
        <ng-container *ngIf="order.price?.total">{{ order.price?.total + ' ' + order.price?.unit }}</ng-container>
        <ng-container *ngIf="!order.price?.total && !(order.weight?.net || order.weight?.gross)">{{ order.count }} {{
          (order.count > 1 ? 'order.countPlural' : 'order.countSingular') | translate}}</ng-container>
      </span>
      <ng-template #noArticle>
        {{ 'order.emptyCount' | translate }}
      </ng-template>
      <i class="fa fa-angle-right"></i>
    </a>
  </section>
  <!-- <section *ngIf="displayScan">
    <button class="btn btn-primary" (click)="startScan()"><i class="fa fa-barcode"></i> {{ 'buttons.scanBarCode' |
      translate }}</button>
  </section> -->
  <section>
    <h6>{{ 'header.menu' | translate }}</h6>
    <ul>
      <ng-container *ngIf="authenticationService.isConnected$ | async; else notLoggedIn">
        <li><a [routerLink]="['/dashboard']"><i class="fa fa-fw fa-home"></i>{{ 'header.home' | translate }}<i
              class="fa fa-angle-right"></i></a></li>
        <li><a [routerLink]="['/user']"><i class="fa fa-fw fa-user"></i>{{ 'header.account' | translate }}<i
              class="fa fa-angle-right"></i></a></li>
        <li><a [routerLink]="['/offers']"><i class="fa fa-fw fa-book-open"></i>{{ 'header.catalog' | translate }}<i
              class="fa fa-angle-right"></i></a></li>
        <li><a id="btn-guide-interactif-mobile" (click)="displayGuideMenu()"><i class="fa fa-fw fa-magic"></i>{{
            'header.guide' | translate }}
            <i class="fa fa-angle-right"></i></a></li>
        <li><a (mouseup)="onLogout()"><i class="fa fa-fw fa-sign-out-alt"></i>{{ 'buttons.logout' | translate }}<i
              class="fa fa-angle-right"></i></a></li>
      </ng-container>
      <ng-template #notLoggedIn>
        <li><a routerLink="/login"><i class="fa fa-fw fa-sign-in-alt"></i>{{ 'buttons.login' | translate }}<i
              class="fa fa-angle-right"></i></a></li>
        <li><a routerLink="/login/forgot"><i class="fa fa-fw fa-unlock-alt"></i>{{ 'buttons.forgot' | translate }}<i
              class="fa fa-angle-right"></i></a></li>
      </ng-template>
    </ul>
  </section>

  <section class="language">
    <h6>{{ 'header.language' | translate }}</h6>
    <ul class="block">
      <li *ngFor="let language of availableLanguages">
        <label class="language-button" (click)="onLanguageFlagClicked(language)"
          [ngClass]="{'active': language === (activeLanguage | async)}">
          <span class="language-flag {{ language }}"></span> {{ 'language.' + language | translate}}
        </label>
      </li>
    </ul>
  </section>
</div>

<!-- Menu des guides (remplace le contenu principal) -->
<div class="wizard-menu-container" *ngIf="showWizardMenu">
  <app-wizard-menu [inline]="true" [theme]="'dark'" (close)="closeWizardMenu()">
  </app-wizard-menu>
</div>

<div class="close-zone" (click)="onClickOutside()"></div>